/* eslint-disable no-else-return */
import { useEffect, useLayoutEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { loadUser } from "../../store/features/Auth/AuthApi";
import { RootStore, useAppDispatch, useAppSelector } from "../../store/store";
import { roles } from "../../helpers/utils/Constants/roles";
import { TENANTPLANSTATUS } from "../../helpers/utils/Constants/tenantPlanStatus";

const ProfileRoute = (props: any) => {
  const navigate = useNavigate();
  const [admin, setAdmin] = useState(false);
  const [authFail, setAuthFail] = useState(false);
  const dispatch = useAppDispatch();

  const authState: any = useAppSelector((store: RootStore) => {
    return store.AuthSlice;
  });

  useLayoutEffect(() => {
    dispatch(loadUser({ setAuthFail: setAuthFail }));
  }, []);
  useEffect(() => {
    if (authFail) {
      navigate("/");
    }
  }, [authFail]);

  useLayoutEffect(() => {
    if (authState.authenticated && authState.tac_user) {
      if (
        authState.tac_user.role === roles.SYSTEM_ADMIN ||
        authState.tac_user.role === roles.SUB_ADMIN ||
        authState.tac_user.role === roles.MENTOR ||
        authState.tac_user.role === roles.TEAMMEMBERSHIP_ADMIN ||
        authState.tac_user.role === roles.TENANT_STUDENT
      ) {
        setAdmin(true);
      }

      if (
        authState.tac_user.role === roles.TEAMMEMBERSHIP_OWNER &&
        authState.tenant_pay_details?.status !== TENANTPLANSTATUS.EXPIRED
      ) {
        setAdmin(true);
      }
      if (
        authState.tac_user.role === roles.TEAMMEMBERSHIP_OWNER &&
        authState.tenant_pay_details?.status === TENANTPLANSTATUS.EXPIRED
      ) {
        navigate("/pay");
      }
    }
  }, [authState.authenticated]);

  if (admin) {
    return <Outlet />;
  } else {
    return null;
  }
};

export default ProfileRoute;
